'use strict';

var React = require('react'),
    Stamp = require('../stamp/Stamp'),
    PageControlsTypes = require('../constants/PageControlsTypes'),
    LightboxStore = require('../stores/LightboxStore'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    getRefinedStamp = require('../utils/getRefinedStamp'),
    createStoreMixin = require('../mixins/createStoreMixin'),
    getDraftPreviewRedirectTarget = require('../utils/getDraftPreviewRedirectTarget'),
    NavigationContextTypes = require('../constants/NavigationContextTypes'),
    Loader = require('../atoms/Loader'),
    ScrollStateMixin = require('../mixins/ScrollStateMixin'),
    AppContext = require('../AppContext'),
    { Navigation } = require('react-router'),
    { PropTypes } = React;

var DraftPreviewPage = React.createClass({
  mixins: [Navigation, PureRenderMixin, createStoreMixin(LightboxStore), ScrollStateMixin],

  statics: {
    willTransitionTo(transition, params) {
      const { stampSegment } = params;
      const [redirectTo, redirectParams] = getDraftPreviewRedirectTarget(stampSegment);

      if (redirectTo) {
        transition.redirect(redirectTo, redirectParams);
      }
    }
  },

  propTypes: {
    draft: PropTypes.object,
    stampSegment: PropTypes.string.isRequired
  },

  getStateFromStores() {
    return {
      lightboxImageUuid: LightboxStore.getActiveImageUuid(),
      lightboxSectionType: LightboxStore.getActiveSectionType()
    };
  },

  getScrollState() {
    return {
      hasScrolledToInfo: this.hasScrolledToOffset(this._infoPanelOffsetTop)
    };
  },

  getPageControls() {
    const { draft, stampSegment } = this.props;
    const { hasScrolledToInfo } = this.state;

    if (!draft || hasScrolledToInfo) {
      return null;
    }

    const { canEdit, uuid: draftUuid } = draft;
    const {
      lightboxImageUuid: imageUuid,
      lightboxSectionType: sectionType
    } = this.state;

    if (imageUuid) {
      return [PageControlsTypes.IMAGE, { imageUuid, sectionType }];
    } else if (canEdit) {
      return [PageControlsTypes.DRAFT_PREVIEW, { stampSegment }];
    } else {
      return [PageControlsTypes.DRAFT_FEEDBACK, { draftUuid }];
    }
  },

  getNavigationContext() {
    return [NavigationContextTypes.DRAFT_PREVIEW];
  },

  getAppContext() {
    const [navigationContextType, navigationContextOptions] = this.getNavigationContext();
    const [pageControlsType, pageControlsOptions] = this.getPageControls() || [];

    return {
      navigationContextType,
      navigationContextOptions,
      pageControlsType,
      pageControlsOptions
    };
  },

  componentWillMount() {
    this._infoPanelOffsetTop = 0;
  },

  render() {
    const { draft } = this.props;
    if (!draft) {
      return <Loader absoluteCenter />;
    }

    const { canEdit } = draft;
    return (
      <AppContext {...this.getAppContext()}>
        <div>
          {draft &&
            <Stamp stamp={getRefinedStamp(draft)}
                   disableInfoPanel={canEdit}
                   showFeedback={!canEdit}
                   onInfoPanelOffsetTopChange={this.handleInfoPanelOffsetTopChange}
                   isLast />
          }
        </div>
      </AppContext>
    );
  },

  handleInfoPanelOffsetTopChange(infoPanelOffsetTop) {
    this._infoPanelOffsetTop = infoPanelOffsetTop;
    this.updateScrollState();
  }
});

module.exports = DraftPreviewPage;



/** WEBPACK FOOTER **
 ** ./pages/DraftPreviewPage.jsx
 **/